import {
  BasicInput,
  Button,
  Chip,
  SectionTitle,
  Yup
} from '@elotech/components';
import { Formik, FormikProps } from 'formik';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

type LevelUpProps = {
  onLevelUp: (codigoValidador: string) => void;
  userNivel: {
    descricao: string;
    nivel: string;
  }[];
  showLevelUpForm: boolean;
  canLevelUp: boolean;
  toggleLevelUpForm: () => void;
};

const validationSchema = Yup.object().shape({
  codigoValidador: Yup.string().required('Código Validador é obrigatório')
});

const LevelUp = ({
  onLevelUp,
  userNivel,
  showLevelUpForm,
  canLevelUp,
  toggleLevelUpForm
}: LevelUpProps) => {
  const onSubmit = ({ codigoValidador }: { codigoValidador: string }) =>
    onLevelUp(codigoValidador);

  return (
    <>
      <SectionTitle hasButton={canLevelUp}>
        Níveis de Acesso
        {canLevelUp && !showLevelUpForm && (
          <Button onClick={toggleLevelUpForm}>ELEVAR NÍVEL</Button>
        )}
      </SectionTitle>

      {showLevelUpForm && (
        <Formik
          initialValues={{
            codigoValidador: ''
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          render={(formProps: FormikProps<{ codigoValidador: string }>) => (
            <Row style={{ display: 'flex', alignItems: 'flex-end' }}>
              <BasicInput
                label={'Código Validador'}
                size={3}
                name={'codigoValidador'}
              />
              <Col md={3}>
                <label className={'label'}> </label>
                <Button onClick={formProps.submitForm}>ELEVAR NÍVEL</Button>
              </Col>
            </Row>
          )}
        />
      )}

      {!showLevelUpForm && userNivel?.length > 0 && (
        <Row>
          <Col md={12}>
            {userNivel &&
              userNivel.map(({ descricao, nivel }) => (
                <Chip
                  inline
                  key={nivel}
                  value={descricao}
                  color="module-color"
                />
              ))}
          </Col>
        </Row>
      )}

      {!showLevelUpForm && !userNivel?.length && (
        <Row>
          <Col md={12}>
            <p>Nenhum nível de acesso registrado.</p>
          </Col>
        </Row>
      )}
    </>
  );
};

export default LevelUp;
